/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ClientConfigurationDormerSpecificSettingsDto } from "./ClientConfigurationDormerSpecificSettings/ClientConfigurationDormerSpecificSettingsDto";

export class ClientConfigurationDto {
    id: string;
    logoUrl: string;
    primaryColor: string;
    secondaryColor: string;
    minWidth: number;
    maxWidth: number;
    minDepth: number;
    maxDepth: number;
    pricePerCubicMeter: number;
    basePrice: number;
    vatPercentage: number;
    extraInformation: string;
    leadPostedSuccessRedirectUrl: string;
    privacyPolicyUrl: string;
    whiteLabelBackOffice: boolean;
    excludeFrameFromCladdingPriceCalculation: boolean;
    clientConfigurationDormerSpecificSettings: ClientConfigurationDormerSpecificSettingsDto;
    priceCalculationStrategyDefaultNoPriceText: string;
    hideOnNoPrice: boolean;
}
